import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import SearchableBlogGrid from "../components/algolia/SearchableBlogGrid.jsx";

export default class SearchableBlogGridModule extends BaseModule {
  init() {
    this.mount = this.el.querySelector("[data-searchable-blog-grid-mount]");
    if (!this.mount) return;

    this.props = {}; // component will resolve envs on its own
    this.render();
  }

  safeParseJSON(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      console.warn("[SearchableBlogGrid] Failed to parse facets JSON", error);
      return [];
    }
  }

  render() {
    if (!this.mount) return;
    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mount);
    }
    this.reactRoot.render(createElement(SearchableBlogGrid, this.props));
  }

  destroy() {
    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }
  }
}
